import { render } from "./gorgias-modal-footer.vue?vue&type=template&id=7fd05b80"
import script from "./gorgias-modal-footer.vue?vue&type=script&lang=js"
export * from "./gorgias-modal-footer.vue?vue&type=script&lang=js"

import "./gorgias-modal-footer.vue?vue&type=style&index=0&id=7fd05b80&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__